import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export function useCategorias() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [newName, setNewName] = useState("");

  const fetchCats = useCallback(async () => {
    try {
      const res = await authAxiosRef.current.get("/financiero/categories");
      setCategories(res.data);
    } catch {} finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { fetchCats(); }, [fetchCats]);

  const createCategory = async () => {
    if (!newName) return;
    try {
      await authAxios.post(`/financiero/categories?name=${encodeURIComponent(newName)}`);
      toast.success("Categoría creada");
      setShowNew(false);
      setNewName("");
      fetchCats();
    } catch {
      toast.error("Error");
    }
  };

  return { categories, loading, showNew, setShowNew, newName, setNewName, createCategory };
}
